import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { getCreatives, fetchCreatives } from 'explore/ducks/creatives';
import CreativesPage from 'explore/components/creatives';

CreativesPage.need = [
  fetchCreatives
];

function mapStateToProps(state) {
  return {
    creativesState: getCreatives(state),
    creativesFetching: getCreatives(state).isFetching,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch, { location }) {
  const actions = {
    fetchCreatives: partial(fetchCreatives, location.query),
  };

  return bindActionCreators(actions, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreativesPage));



// WEBPACK FOOTER //
// ./explore/containers/creatives.jsx